import React, { useEffect, useState } from 'react';
import '../../scss/entity_settings.scss';
import getResponseEntity from '../actions/Entity.js';
import AddAssignment from '../popups/AddAssignment';
import AddEntity from '../popups/AddEntity';
import AddAttribute from '../popups/AddAttribute';
import AddContact from '../popups/AddContact';
import { CSVLink } from "react-csv";
import DeleteItem from '../popups/DeleteItem';
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
import RefreshToken from '../actions/RefreshToken';
import { useDispatch } from 'react-redux';
import { parseEntityId } from '../../store/Actions'
import create from '../../images/common/add.png';
import trash from '../../images/common/trash.png';
import edit from '../../images/common/edit-blue.png';
import download from '../../images/common/download-blue.png';
import upsort from '../../images/common/upsort.png';
import downsort from '../../images/common/downsort.png';
import Snackbars from '../Reusables/Snackbar';

function EntitySettings(props) {
    const { entityId } = props;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const accessToken =  Cookies.get('access_token');
    const [assignmentData, setAssignmentData] = useState(null);
    const [entitiesData, setEntitiesData] = useState(null);
    const [contactsData, setContactsData] = useState(null);
    const [attributesData, setAttributesData] = useState(null);
    const [showAssignment, setShowAssignment] = useState(false);
    const [showEntities, setShowEntities] = useState(false);
    const [showContacts, setShowContacts] = useState(false);
    const [showAttributes, setShowAttributes] = useState(false);
    const [type, setType] = useState(null);
    const [reloadAssignment, setReloadAssignment] = useState(false);
    const [reloadContacts, setReloadContacts] = useState(false);
    const [reloadEntities, setReloadEntities] = useState(false);
    const [reloadAttributes, setReloadAttributes] = useState(false);
    const [csvEntitiesData, setCsvEntitiesData] = useState(null);
    const [csvContactsData, setCsvContactsData] = useState(null);
    const [csvAttributesData, setCsvAttributesData] = useState(null);
    const [deleteAssignmentId, setDeleteAssignment] = useState(null);
    const [deleteContactId, setDeleteContact] = useState(null);
    const [deleteEntityId, setDeleteEntity] = useState(null);
    const [deleteAttributeId, setDeleteAttribute] = useState(null);
    const [entityerror, setEntityerror] = useState('');
    const [attributeerror, setAttributeerror] = useState('');
    const [addentitytoggle, setaddentitytoggle] = useState(false);
    const [defaulttoggle, setdefaulttoggle] = useState(false);
    const [assignmenterror, setAssignmenterror] = useState('');
    const [userId, setUserId] = useState(null);
    const [label, setLabel] = useState('Select User');
    const [attributetoggle, setAttributetoggle] = useState(false);
    const [enable, setEnable] = useState(true);
    const [enableEntity, setEnableEntity] = useState(true);
    const [enableAttribute, setEnableAttribute] = useState(true);
    const [openAttribute, setOpenAttribute] = useState(null);
    const [openAssignment, setOpenAssignment] = useState(null);
    const [openEntity, setOpenEntity] = useState(null);
    const [sortValues, setSortValues] = useState({
        sortBy: null,
        sortType: null
    })
    const [sortValuesAttribute, setSortValuesAttribute] = useState({
        sortBy: null,
        sortType: null
    })
    const [sortValuesContact, setSortValuesContact] = useState({
        sortBy: null,
        sortType: null
    })
    const assignmentTableHeaders = [
        { "name": "Name", "sort": false, "width": "200px" },
        { "name": "Email", "sort": false, "width": "200px" },
        { "name": "Actions", "sort": false, "width": "200px" }
    ];
    const contactsTableHeaders = [
        { "name": "Name", "sort": true, "width": "200px" },
        { "name": "Relationships", "sort": false, "width": "200px" },
        { "name": "Email", "sort": false, "width": "200px" },
        { "name": "Actions", "sort": false, "width": "200px" }
    ];
    const entityTableHeaders = [
        { "name": "Name", "sort": true, "width": "200px" },
        { "name": "Relationships", "sort": false, "width": "200px" },
        { "name": "Actions", "sort": false, "width": "200px" }
    ];
    const attributeTableHeaders = [
        { "name": "Name", "sort": true, "width": "200px" },
        { "name": "Value", "sort": false, "width": "200px" },
        { "name": "Actions", "sort": false, "width": "200px" }
    ];
    const csvEntitiesHeaders = [
        { label: "Name", key: "name" },
        { label: "Relationships", key: "relationship" }
    ];
    const csvContactsHeaders = [
        { label: "Name", key: "name" },
        { label: "Relationships", key: "relationShipType" },
        { label: "Email", key: "email" }
    ];
    const csvAttributesHeaders = [
        { label: "Name", key: "attributeName" },
        { label: "Value", key: "value" }
    ];

    const [showDeleteAssignment, setShowDeleteAssignment] = useState(false);
    const handleCloseDeleteAssignmentPopup = () => setShowDeleteAssignment(false);
    const handleShowDeleteAssignmentPopup = () => setShowDeleteAssignment(true);

    const [showDeleteContact, setShowDeleteContact] = useState(false);
    const handleCloseDeleteContactPopup = () => setShowDeleteContact(false);
    const handleShowDeleteContactPopup = () => setShowDeleteContact(true);

    const [showDeleteEntity, setShowDeleteEntity] = useState(false);
    const handleCloseDeleteEntityPopup = () => setShowDeleteEntity(false);
    const handleShowDeleteEntityPopup = () => setShowDeleteEntity(true);

    const [showDeleteAttribute, setShowDeleteAttribute] = useState(false);
    const handleCloseDeleteAttributePopup = () => setShowDeleteAttribute(false);
    const handleShowDeleteAttributePopup = () => setShowDeleteAttribute(true);

    useEffect(() => {
        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                callDefaultAssignmentListApi(accesstoken);
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }, [reloadAssignment])

    useEffect(() => {
        callContactsListApi();
    }, [reloadContacts])

    useEffect(() => {
        callEntitiesListApi();
    }, [reloadEntities])

    useEffect(() => {
        callAttributesListApi();
    }, [reloadAttributes])

    const handleCloseAssignment = () => {
        setShowAssignment(false);
    }

    const handleShowAssignment = (type) => {
        setType(type);
        setShowAssignment(true);
        setAssignmenterror('');
        setOpenAssignment(false);
    }

    const handleShowAssignmentAdd = (type) => {
        setType(type);
        setShowAssignment(true);
        setdefaulttoggle(!defaulttoggle);
        setAssignmenterror('');
        setOpenAssignment(false);
        setEnable(true);
    }

    const handleCloseEntities = () => {
        setShowEntities(false);
    }

    const handleShowEntities = () => {
        setShowEntities(true);
        setEntityerror('');
        setOpenEntity(false);
        setaddentitytoggle(!addentitytoggle);
    }

    const handleCloseAttributes = () => {
        setShowAttributes(false);
    }

    const handleShowAttributes = () => {
        setShowAttributes(true);
        setAttributeerror('');
        setOpenAttribute(false);
        setAttributetoggle(!attributetoggle);
    }

    const handleCloseContacts = () => {
        // setShowContacts(false);
    }

    const handleShowContacts = () => {
        // setShowContacts(true);
        // Redirect to Create New Contact page
        navigate('/contacts/new');
        console.log(entityId)
        dispatch(parseEntityId(entityId))
    }

    const callDefaultAssignmentListApi = (accesstoken) => {
        accessToken && getResponseEntity.GetDefaultAssignments(`/api/entity/default_assignment/list?entityId=${entityId}`, accesstoken, (data) => {
            if (data.status == 200) {
                console.log("data.data.data", data.data.data);
                setAssignmentData(data.data.data);
                setUserId(data.data.data.idUsers);
                setLabel(data.data.data.lastName != null ? data.data.data.firstName+" "+data.data.data.lastName : data.data.data.firstName);
            } else if(data.status == 401) {
                navigate("/login")
            }
        });
    }

    const callEntitiesListApi = () => {
        accessToken && getResponseEntity.GetEntities(`/api/entity/relation/list?entityId=${entityId}`, accessToken, (data) => {
            if (data.status == 200) {
                setEntitiesData(data.data.data);
                const csvDataArray = [];
                data.data.data.map((entity) => {
                    const entityObject = {name: '', relationship: ''}
                    entityObject.name = entity.relatedEntity.name;
                    entityObject.relationship = entity.relationShipType;
                    csvDataArray.push(entityObject);
                })
                setCsvEntitiesData(csvDataArray);
            } else if(data.status == 401) {
                navigate("/login")
            }
        });
    }

    const getAssignment = (userId) => {
        const details = {
            UserId: userId,
            EntityId: entityId
        }

        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                if(type == 'edit') {
                    {/* TODO: Need to get it from list */}
                    details.IdAssignments = assignmentData.idAssignments;
                    getResponseEntity.EditDefaultAssignments('/api/entity/default_assignment/update', accesstoken, details, (data) => {
                        if (data.status == 200) {
                            setReloadAssignment(!reloadAssignment);
                            handleCloseAssignment();
                        }
                        if (data.status == 400) {
                            setAssignmenterror(data.data.message);
                            setOpenAssignment(true);     
                            setOpenAttribute(false);
                            setOpenEntity(false);
                        } else if(data.status == 401) {
                            navigate("/login")
                        } 
                    });
                } else {
                    getResponseEntity.AddDefaultAssignments('/api/entity/default_assignment/add', accesstoken, details, (data) => {
                        if (data.status == 200) {
                            setReloadAssignment(!reloadAssignment);
                            handleCloseAssignment();
                        }
                        if (data.status == 400) {
                            setAssignmenterror(data.data.message);
                            setOpenAssignment(true);     
                            setOpenAttribute(false);
                            setOpenEntity(false);                        
                        } else if(data.status == 401) {
                            navigate("/login")
                        }  
                    });
                }
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }

    function deleteAssignment(id) {
        console.log("Assignment id", id);
        setDeleteAssignment(id);
        handleShowDeleteAssignmentPopup();
    }

    const handleDeleteAssignment = (id) => {
        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                getResponseEntity.DeleteDefaultAssignments(`/api/entity/default_assignment/delete?assignmentId=${deleteAssignmentId}`, accesstoken, (data) => {
                    if (data.status == 200) {
                        setReloadAssignment(!reloadAssignment);
                        handleCloseDeleteAssignmentPopup();
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                });        
            }
        }
        RefreshToken((accesstoken) => callApi(accesstoken));
    }

    const GetEntities = (details) => {
        details.CurrentEntity = entityId
        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                getResponseEntity.AddEntity('/api/entity/relation/add', accesstoken, details, (data) => {
                    setEnableEntity(true);
                    if (data.status == 200) {
                        setReloadEntities(!reloadEntities);
                        handleCloseEntities();
                        setEntityerror('');
                        setOpenEntity(false);
                    }
                    if (data.status == 400) {
                        setEntityerror(data.data.message);
                        setOpenEntity(true);
                        setOpenAttribute(false);
                        setOpenAssignment(false);
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }

    function deleteEntity(id) {
        setDeleteEntity(id);
        handleShowDeleteEntityPopup();
    }

    const handleDeleteEntity = (id) => {
        const callApi = (accesstoken) => {
            getResponseEntity.DeleteEntity(`/api/entity/relation/delete?entityRelationId=${deleteEntityId}`, accesstoken, (data) => {
                if (data.status == 200) {
                    setReloadEntities(!reloadEntities);
                    handleCloseDeleteEntityPopup()
                } else if(data.status == 401) {
                    navigate("/login")
                }
            });
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }

    const handleSort = (dataset) => {
        setSortValues({
            sortBy: dataset.sortBy,
            sortType: dataset.sortType
        })
        if(dataset.sortBy == "Name") {
            if(dataset.sortType == "asc") {
                entitiesData.sort((a, b) => (a.relatedEntity.name.toUpperCase() > b.relatedEntity.name.toUpperCase()) ? 1 : -1);
            } else {
                entitiesData.sort((a, b) => (a.relatedEntity.name.toUpperCase() < b.relatedEntity.name.toUpperCase()) ? 1 : -1);
            }
        }
        setEntitiesData([...entitiesData])
    }

    const callAttributesListApi = () => {
        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                getResponseEntity.GetAttributes(`/api/entity/attribute/list?entityId=${entityId}`, accesstoken, (data) => {
                    if (data.status == 200) {
                        setAttributesData(data.data.data);
                        const csvDataArray = [];
                        data.data.data.map((attribute) => {
                            const attributeObject = {attributeName: '', value: ''}
                            attributeObject.attributeName = attribute.attributeName;
                            attributeObject.value = attribute.value;
                            csvDataArray.push(attributeObject);
                        })
                        setCsvAttributesData(csvDataArray);
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }

    const GetAttributes = (details) => {
        details.EntityId = entityId
        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                getResponseEntity.AddAttribute('/api/entity/attribute/add', accesstoken, details, (data) => {
                    setEnableAttribute(true);
                    if (data.status == 200) {
                        setReloadAttributes(!reloadAttributes);
                        handleCloseAttributes();
                        setAttributeerror('');
                        setOpenAttribute(false);
                    }
                    if (data.status == 400) {
                        setAttributeerror(data.data.message);
                        setOpenAttribute(true);         
                        setOpenEntity(false);
                        setOpenAssignment(false);
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }

    function deleteAttribute(id) {
        setDeleteAttribute(id);
        handleShowDeleteAttributePopup();
    }

    const handleDeleteAttribute = (id) => {
        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                getResponseEntity.DeleteAttribute(`/api/entity/attribute/delete?entityAttributeId=${deleteAttributeId}`, accesstoken, (data) => {
                    if (data.status == 200) {
                        setReloadAttributes(!reloadAttributes);
                        handleCloseDeleteAttributePopup()
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }

    const handleSortAttribute = (dataset) => {
        setSortValuesAttribute({
            sortBy: dataset.sortBy,
            sortType: dataset.sortType
        })
        if(dataset.sortBy == "Name") {
            if(dataset.sortType == "asc") {
                attributesData.sort((a, b) => (a.attributeName.toUpperCase() > b.attributeName.toUpperCase()) ? 1 : -1);
            } else {
                attributesData.sort((a, b) => (a.attributeName.toUpperCase() < b.attributeName.toUpperCase()) ? 1 : -1);
            }
        }
        setAttributesData([...attributesData])
    }

    const callContactsListApi = () => {
        accessToken && getResponseEntity.GetContacts(`/api/entity/contacts/list?entityId=${entityId}`, accessToken, (data) => {
            if (data.status == 200) {
                setContactsData(data.data.data);
                const csvContactDataArray = [];
                data.data.data.map((contact) => {
                    const contactObject = {name: '', relationShipType: '', email: ''}
                    contactObject.name = contact.name;
                    contactObject.relationShipType = contact.relationShipType;
                    contactObject.email = contact.email;
                    csvContactDataArray.push(contactObject);
                })
                setCsvContactsData(csvContactDataArray);
            } else if(data.status == 401) {
                navigate("/login")
            }
        });
    }

    const GetContacts = (details) => {
        details.EntityId = entityId
        
        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                getResponseEntity.AddContact('/api/entity/contacts/add', accesstoken, details, (data) => {
                    if (data.status == 200) {
                        setReloadContacts(!reloadContacts);
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                });      
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }

    function deleteContact(id) {
        setDeleteContact(id);
        handleShowDeleteContactPopup();
    }

    const handleDeleteContact = () => {
        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                getResponseEntity.DeleteContact(`/api/entity/contacts/delete?entityContactRelationId=${deleteContactId}`, accesstoken, (data) => {
                    if (data.status == 200) {
                        setReloadContacts(!reloadContacts);
                        handleCloseDeleteContactPopup();
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }

    const handleSortContact = (dataset) => {
        setSortValuesContact({
            sortBy: dataset.sortBy,
            sortType: dataset.sortType
        })
        if(dataset.sortBy == "Name") {
            if(dataset.sortType == "asc") {
                contactsData.sort((a, b) => (a.name.toUpperCase() > b.name.toUpperCase()) ? 1 : -1);
            } else {
                contactsData.sort((a, b) => (a.name.toUpperCase() < b.name.toUpperCase()) ? 1 : -1);
            }
        }
        setContactsData([...contactsData])
    }


    return(
        <>
            <div className='entity-settings-container'>
                <div className='default-assignments-container'>
                    <div className='header-container'>
                        <div className='header-label'>Default Assignments</div>
                        {(assignmentData != null && assignmentData.idUsers != 0) ? <div className='edit-btn' onClick={() => handleShowAssignment('edit')}><img src={edit}/></div> : 
                        <div className='add-btn'><img src={create} onClick={() => handleShowAssignmentAdd('add')}/></div>}
                    </div>
                    <div className='body-container'>
                        {/* TODO: Need to change the condition */}
                        {assignmentData != null && assignmentData.idUsers == 0 ? 
                        (<div className='no-assignments-label'>There are no assignments to display</div>) : 
                        (<div className='table-view-container'>
                            <div className='list-items'>
                                <table>
                                    <thead>
                                        <tr className='heading-row'>
                                            {assignmentTableHeaders.map((item, index) => {
                                                return (
                                                    <>
                                                        <th className={`${'heading-data'+index}`} style={{ minWidth: `${item.width}` }}>
                                                            <div className='flex-display'>
                                                                <div className='label'>{item.name}</div>  
                                                            </div>                                  
                                                        </th>
                                                    </>
                                                )
                                            })}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {assignmentData != null && 
                                            <tr>
                                                {console.log("[Default Assignment]", assignmentData.firstName)}
                                                <td className='task-data1'>{assignmentData.lastName != null ? assignmentData.firstName+" "+assignmentData.lastName : assignmentData.firstName}</td>
                                                <td className='task-data2'>{assignmentData.email}</td>
                                                <td className='task-data3'>
                                                    <div>
                                                        <img id={`${'trash'+0}`} className='trash' src={trash} alt="delete" onClick={() => deleteAssignment(assignmentData.idAssignments)}></img>
                                                    </div>
                                                </td>
                                            </tr>}
                                    </tbody>
                                </table>
                            </div>
                        </div>)}
                    </div>

                     {/* Showing Add Default Assignment popup */}
                     {assignmentData != null && 
                     <AddAssignment setLabel={setLabel} label={label} setEnable={setEnable} enable={enable} setUserId={setUserId} userId={userId} assignmenterror={null} show={showAssignment} handleClose={handleCloseAssignment} getDetails={getAssignment} defaulttoggle={defaulttoggle}
                     type={type}/>}
                     <Snackbars error={assignmenterror} open={openAssignment} setOpen={setOpenAssignment}/>
                    {/* Showing delete popup */}
                    <DeleteItem show={showDeleteAssignment} handleClose={handleCloseDeleteAssignmentPopup} deleteApiCall={handleDeleteAssignment} enable={true}/>
                </div>

                {/* <div className='contacts-container'>
                    <div className='header-container'>
                        <div className='header-label'>Contacts</div>
                        <div className='add-download-btn'>
                            {csvContactsData != null && 
                            <CSVLink data={csvContactsData} headers={csvContactsHeaders} filename={"Contacts.csv"}>
                                <img className='download-btn' src={download}/>
                            </CSVLink>
                            }
                            <img className='add-btn' src={create} onClick={handleShowContacts}/>
                        </div>
                    </div>
                    <div className='body-container'>
                        <div className='table-view-container'>
                            <div className='list-items'>
                                <table>
                                    <thead>
                                        <tr className='heading-row'>
                                            {contactsTableHeaders.map((item, index) => {
                                                return (
                                                    <>
                                                        <th className={`${'heading-data'+index}`} style={{ minWidth: `${item.width}` }}>
                                                            <div className='flex-display'>
                                                                <div className='label'>{item.name}</div> 
                                                                {item.sort &&
                                                                (<div className='sort-arrows'>
                                                                    {
                                                                        !(sortValuesContact.sortBy === item.name && sortValuesContact.sortType === 'asc') &&
                                                                        <img className='uparrow' src={upsort} alt="uparrow" 
                                                                        data-sort-by={item.name} data-sort-type='asc' onClick={(e) => handleSortContact(e.target.dataset)}></img>
                                                                    }
                                                                    {
                                                                        !(sortValuesContact.sortBy === item.name && sortValuesContact.sortType === 'desc') &&
                                                                        <img className='downarrow' src={downsort} alt="downarrow"
                                                                        data-sort-by={item.name} data-sort-type='desc' onClick={(e) => handleSortContact(e.target.dataset)}></img>
                                                                    }
                                                                </div>)} 
                                                            </div>                                  
                                                        </th>
                                                    </>
                                                )
                                            })}
                                        </tr>
                                    </thead>
                                    {
                                    contactsData && contactsData.length === 0 ? <p className="no-result">No results found</p> :
                                        <tbody>
                                            {(contactsData != null && contactsData.length > 0) && 
                                                contactsData.map((item, index) => {
                                                    return(
                                                        <tr>
                                                            <td className='task-data1'>{item.name}</td>
                                                            <td className='task-data2'>{item.relationShipType}</td>
                                                            <td className='task-data3'>{item.email}</td>
                                                            <td className='task-data4'>
                                                                <div>
                                                                    <img id={`${'trash'+0}`} className='trash' src={trash} alt="delete" 
                                                                    onClick={() => deleteContact(item.idcontactsEntityRelation)}></img>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    }
                                </table>
                            </div>
                        </div>
                    </div> */}

                     {/* Showing delete popup */}
                    {/* <DeleteItem show={showDeleteContact} handleClose={handleCloseDeleteContactPopup} deleteApiCall={handleDeleteContact} enable={true}/>
                </div> */}

                <div className='entities-container'>
                    <div className='header-container'>
                        <div className='header-label'>Properties</div>
                        <div className='add-download-btn'>
                            {csvEntitiesData != null && 
                            <CSVLink data={csvEntitiesData} headers={csvEntitiesHeaders} filename={"Properties.csv"}>
                                <img className='download-btn' src={download}/>
                            </CSVLink>
                            }
                            <img className='add-btn' src={create} onClick={handleShowEntities}/>
                        </div>
                    </div>
                    <div className='body-container'>
                        <div className='table-view-container'>
                            <div className='list-items'>
                                <table>
                                    <thead>
                                        <tr className='heading-row'>
                                            {entityTableHeaders.map((item, index) => {
                                                return (
                                                    <>
                                                        <th className={`${'heading-data'+index}`} style={{ minWidth: `${item.width}` }}>
                                                            <div className='flex-display'>
                                                                <div className='label'>{item.name}</div> 
                                                                {item.sort &&
                                                                (<div className='sort-arrows'>
                                                                    {
                                                                        !(sortValues.sortBy === item.name && sortValues.sortType === 'asc') &&
                                                                        <img className='uparrow' src={upsort} alt="uparrow" 
                                                                        data-sort-by={item.name} data-sort-type='asc' onClick={(e) => handleSort(e.target.dataset)}></img>
                                                                    }
                                                                    {
                                                                        !(sortValues.sortBy === item.name && sortValues.sortType === 'desc') &&
                                                                        <img className='downarrow' src={downsort} alt="downarrow"
                                                                        data-sort-by={item.name} data-sort-type='desc' onClick={(e) => handleSort(e.target.dataset)}></img>
                                                                    }
                                                                </div>)} 
                                                            </div>                                  
                                                        </th>
                                                    </>
                                                )
                                            })}
                                        </tr>
                                    </thead>
                                    {
                                    entitiesData && entitiesData.length === 0 ? <p className="no-result">No results found</p> :
                                        <tbody>
                                            {(entitiesData != null && entitiesData.length > 0) && 
                                                entitiesData.map((item, index) => {
                                                    return(
                                                        <tr>
                                                            <td className='task-data1'>{item.relatedEntity.name}</td>
                                                            <td className='task-data2'>{item.relationShipType}</td>
                                                            <td className='task-data3'>
                                                                <div>
                                                                    <img id={`${'trash'+0}`} className='trash' src={trash} alt="delete" 
                                                                    onClick={() => deleteEntity(item.idEntityRelation)}></img>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    }
                                </table>
                            </div>
                        </div>
                    </div>

                     {/* Showing Add Entity popup */}
                     <AddEntity show={showEntities} handleClose={handleCloseEntities} enableEntity={enableEntity} setEnableEntity={setEnableEntity} getEntityDetails={GetEntities} entityerror={null} entityId={entityId} addentitytoggle={addentitytoggle}/>
                     <Snackbars error={entityerror} open={openEntity} setOpen={setOpenEntity}/>
                     {/* Showing delete popup */}
                    <DeleteItem show={showDeleteEntity} handleClose={handleCloseDeleteEntityPopup} deleteApiCall={handleDeleteEntity} enable={true}/>
                </div>

                <div className='attributes-container'>
                    <div className='header-container'>
                        <div className='header-label'>Additional Attributes</div>
                        <div className='add-download-btn'>
                            {csvAttributesData != null && 
                            <CSVLink data={csvAttributesData} headers={csvAttributesHeaders} filename={"Attributes.csv"}>
                                <img className='download-btn' src={download}/>
                            </CSVLink>
                            }
                            <img className='add-btn' src={create} onClick={handleShowAttributes}/>
                        </div>
                    </div>
                    <div className='body-container'>
                        <div className='table-view-container'>
                            <div className='list-items'>
                                <table>
                                    <thead>
                                        <tr className='heading-row'>
                                            {attributeTableHeaders.map((item, index) => {
                                                return (
                                                    <>
                                                        <th className={`${'heading-data'+index}`} style={{ minWidth: `${item.width}` }}>
                                                            <div className='flex-display'>
                                                                <div className='label'>{item.name}</div> 
                                                                {item.sort &&
                                                                (<div className='sort-arrows'>
                                                                    {
                                                                        !(sortValuesAttribute.sortBy === item.name && sortValuesAttribute.sortType === 'asc') &&
                                                                        <img className='uparrow' src={upsort} alt="uparrow" 
                                                                        data-sort-by={item.name} data-sort-type='asc' onClick={(e) => handleSortAttribute(e.target.dataset)}></img>
                                                                    }
                                                                    {
                                                                        !(sortValuesAttribute.sortBy === item.name && sortValuesAttribute.sortType === 'desc') &&
                                                                        <img className='downarrow' src={downsort} alt="downarrow"
                                                                        data-sort-by={item.name} data-sort-type='desc' onClick={(e) => handleSortAttribute(e.target.dataset)}></img>
                                                                    }
                                                                </div>)} 
                                                            </div>                                  
                                                        </th>
                                                    </>
                                                )
                                            })}
                                        </tr>
                                    </thead>
                                    {
                                    attributesData && attributesData.length === 0 ? <p className="no-result">No results found</p> :
                                        <tbody>
                                            {(attributesData != null && attributesData.length > 0) && 
                                                attributesData.map((item, index) => {
                                                    return(
                                                        <tr>
                                                            <td className='task-data1'>{item.attributeName}</td>
                                                            <td className='task-data2'>{item.value}</td>
                                                            <td className='task-data3'>
                                                                <div>
                                                                    <img id={`${'trash'+0}`} className='trash' src={trash} alt="delete" 
                                                                    onClick={() => deleteAttribute(item.idEntityAttributesRelation)}></img>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    }
                                </table>
                            </div>
                        </div>
                    </div>

                     {/* Showing Add Attribute popup */}
                     <AddAttribute show={showAttributes} handleClose={handleCloseAttributes} getAttributeDetails={GetAttributes} attributeerror={null} attributetoggle={attributetoggle} setEnableAttribute={setEnableAttribute} enableAttribute={enableAttribute}/>
                     <Snackbars error={attributeerror} open={openAttribute} setOpen={setOpenAttribute}/>

                     {/* Showing delete popup */}
                    <DeleteItem show={showDeleteAttribute} handleClose={handleCloseDeleteAttributePopup} deleteApiCall={handleDeleteAttribute} enable={true}/>
                </div>
            </div>
        </>
    )
}

export default EntitySettings;